export const Monogram = ({ size = 40, dark = false }) => (
  <svg width={size} height={size} viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
    <path d="M50 5 L95 27.5 L95 72.5 L50 95 L5 72.5 L5 27.5 Z" stroke="#C5A059" strokeWidth="2" fill="none" />
    <text x="29" y="59" fontFamily="'Cormorant Garamond', Georgia, serif" fontSize="37" fontWeight="600" fill={dark ? "#FBF9F5" : "#2B1810"}>S</text>
    <text x="46" y="63" fontFamily="'Cormorant Garamond', Georgia, serif" fontSize="22" fontStyle="italic" fill="#C5A059">&amp;</text>
    <text x="57" y="68" fontFamily="'Cormorant Garamond', Georgia, serif" fontSize="37" fontWeight="600" fill={dark ? "#FBF9F5" : "#2B1810"}>S</text>
    <circle cx="50" cy="15" r="2.4" fill="#C5A059" />
  </svg>
);

export const Wordmark = ({ dark = false, compact = false }) => (
  <span className="flex items-center gap-3">
    <Monogram size={compact ? 34 : 40} dark={dark} />
    <span className="flex flex-col leading-none">
      <span className={`font-serif text-lg md:text-xl font-semibold tracking-wide ${dark ? "text-cream" : "text-chocolate"}`}>
        Salem <span className="italic text-gold">&amp;</span> Sabrina
      </span>
      {!compact && (
        <span className="font-mono text-[9px] uppercase tracking-[0.35em] text-golddark mt-1">The Gift Edit</span>
      )}
    </span>
  </span>
);
